// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__tHFQc","seasonDetail":"Layout_seasonDetail__HdRkR"};